import React from 'react';
import {Navigate, Route, Routes} from 'react-router';
import {Box, Flex} from '@chakra-ui/react';
import {IntentTabs} from './IntentTabs';
import {ScrollableFlex, WrapperFlex} from '../utils/scrolling';
import {DotBackground} from '../utils/background';

export const IntentModelContent = () => {
  return (
    <Flex
      bgColor="kgray.100"
      flex="1"
      justifyContent="center"
      position="relative"
      _before={DotBackground}
    >
      <Flex h="100%" zIndex="1">
        <WrapperFlex>
          <ScrollableFlex alignItems="center" px="2" py="6">
            <Box maxW="2xl" w="100%">
              <Routes>
                {IntentTabs.map(({path, element}) => (
                  <Route key={path} path={path} element={element} />
                ))}
                <Route
                  path="*"
                  element={<Navigate to={IntentTabs[0].path} replace={true} />}
                />
              </Routes>
            </Box>
          </ScrollableFlex>
        </WrapperFlex>
      </Flex>
    </Flex>
  );
};
